import { render, staticRenderFns } from "./RouteVersion.vue?vue&type=template&id=2e16cbd3"
import script from "./RouteVersion.vue?vue&type=script&lang=js"
export * from "./RouteVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports